// extracted by mini-css-extract-plugin
export default {"container":"LFCdo47 zFMy58l","noisyText":"Y2PWTTx zFMy58l"};